import { createReducer } from '@reduxjs/toolkit';

import postFedexPickup, { clearPostFedexPickup } from '../../thunks/fedex/pickup';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postFedexPickupReducer = createReducer(initialState, {
  [postFedexPickup.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postFedexPickup.fulfilled]: (state, { payload: data }) => ({
    ...state,
    data,
    loading: false,
  }),
  [clearPostFedexPickup]: () => initialState,
  [postFedexPickup.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default postFedexPickupReducer;
